import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthorsRoutingModule} from './authors-routing.module';
import {AuthorsComponent} from './authors.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {AddAuthorComponent} from './add-author/add-author.component';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
// @ts-ignore
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [AuthorsComponent, AddAuthorComponent],
    imports: [
        CommonModule,
        AuthorsRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [AuthorsComponent, AddAuthorComponent]
})

export class AuthorsModule {
}
